import { render, staticRenderFns } from "./hcmChildforward.vue?vue&type=template&id=d649d5a0"
import script from "./hcmChildforward.vue?vue&type=script&lang=js"
export * from "./hcmChildforward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports